const lumegemWhatsappSelectors = [
  '#wa-force-btn',
  '.dynamic-wa-link',
  'a[href*="wa.me"]',
  'a[href*="api.whatsapp.com"]',
  'a[href*="whatsapp" i]'
];

function removeLumegemWhatsappButtons() {
  lumegemWhatsappSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((node) => {
      node.remove();
    });
  });
}

removeLumegemWhatsappButtons();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeLumegemWhatsappButtons, { once: true });
}

window.addEventListener('load', removeLumegemWhatsappButtons, { once: true });

new MutationObserver(removeLumegemWhatsappButtons).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['href', 'class', 'id', 'style']
});
